export default "__VITE_ASSET__C3d55ZNe__"